import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { useLanguage } from './i18n';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: (count, err: any) => err?.status >= 500 && count < 2, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LanguageRoot />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

/** Re-renders translated text without discarding form state when the language changes. */
function LanguageRoot() {
  useLanguage();
  return <App />;
}
